module.exports = __webpack_public_path__ + "static/img/iconFaltCode.9d50e6b.png";